module.exports = __webpack_public_path__ + "static/media/brinquedo12.ffe09013.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo12.jpg
// module id = 68
// module chunks = 0